import moment from "moment";
import { CalendarDate } from "./calendar-date";
function yearsBetween(basis, target) {
    return moment(basis).diff(moment(target), "years");
}
// Useful for calculating Age given a birthday. Can be used
// for other analogous date calculations too.
export function getYearsSince(date) {
    if (!date) {
        return 0;
    }
    // Set now for midnight "tonight". If today is their birthday,
    // they've already celebrated it and should could the new year
    // even if we've recorded their birthdate time as some time later
    // today.
    const now = new Date();
    now.setUTCDate(now.getUTCDate() + 1);
    now.setHours(0);
    return Math.floor(Math.abs(yearsBetween(now, date)));
}
export function getYearsSinceAsString(date) {
    const comparableDate = date instanceof CalendarDate ? date.toDate() : date;
    const yearsSince = getYearsSince(comparableDate);
    if (yearsSince == 0) {
        return "";
    }
    return "" + yearsSince;
}
//# sourceMappingURL=helper-functions.js.map